import React from "react";

import {
  currentStepDoubleSleeperMattressBuilderSelector,
  currentStepSingleSleeperMattressBuilderSelector,
  currentlyEditingSleeperSelector,
  setCurrentStepDoubleSleeperMattressBuilder,
  setCurrentStepSingleSleeperMattressBuilder,
  setIsSummaryModalOpen,
} from "../../../../redux/slices/customNavigation";
import { isSingleSleeperSelector } from "../../../../redux/slices/mattressConfiguration";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { FlapComponent } from "./FlapComponent";
import ClosedFlapButton from "./ClosedFlapButton";
import ClosedFlapTitle from "./ClosedFlapTitle";
import ReactGA from "react-ga";

const SummaryButton = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isSingleSleeper = useSelector(isSingleSleeperSelector);

  const currentlyEditingSleeper = useSelector(currentlyEditingSleeperSelector);

  const editingSleeper1 = currentlyEditingSleeper === 1;

  const currentStepSingleSleeperMattressBuilder = useSelector(
    currentStepSingleSleeperMattressBuilderSelector
  );
  const currentStepDoubleSleeperMattressBuilder = useSelector(
    currentStepDoubleSleeperMattressBuilderSelector
  );

  const currentStep =
    isSingleSleeper || editingSleeper1
      ? currentStepSingleSleeperMattressBuilder
      : currentStepDoubleSleeperMattressBuilder;

  const doubleSleeperNextFunction = index => {
    dispatch(setCurrentStepDoubleSleeperMattressBuilder(index));
    dispatch(setIsSummaryModalOpen(true));
  };

  const singleSleeperNextFunction = index => {
    dispatch(setCurrentStepSingleSleeperMattressBuilder(index));
    dispatch(setIsSummaryModalOpen(true));
  };

  const nextFunction =
    isSingleSleeper || editingSleeper1
      ? singleSleeperNextFunction
      : doubleSleeperNextFunction;

  return (
    <FlapComponent
      index={4}
      currentStep={currentStep}
      styles={{
        background:
          "transparent linear-gradient(160deg, #174d63 0%, #092c3b 100%) 0%",
        boxShadow: "",
        borderColor: "transparent",
        color: "white",
      }}
    >
      <ClosedFlapButton index={4} onClick={index => {
        nextFunction(index);
        ReactGA.pageview('/mattress-builder/summary-modal');
      }}>
        <ClosedFlapTitle styles={{ color: "white" }}>
          {t("SUMMARY")}
        </ClosedFlapTitle>
      </ClosedFlapButton>
    </FlapComponent>
  );
};

export default SummaryButton;
